export default __webpack_public_path__ + "static/media/ITR-1.f020dfd5.png";